import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faPlay, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function Movie({ movie, handleMovieClick, isActive, movieFocus, isMessage }) {
	const base_url = "https://image.tmdb.org/t/p/original";

	function truncate(str, n) {
		return str?.length > n ? str.substr(0, n - 1) + "..." : str;
	}

	return (
		<div
			onClick={() => movieFocus(movie)}
			className={`movie-item ${isActive ? " movie-item-big" : ""} `}
		>
			<div className="movie-img">
				<div className="movie-rating">
					{movie.vote_average}{" "}
					<FontAwesomeIcon icon={faStar} />
				</div>
				<img
					className="row__poster row__posterLarge"
					src={`${base_url}${movie.poster_path}`}
					alt={movie.name}
				/>
			</div>

			<div className="movie-data">
				<h3>{movie.title || movie?.name || movie?.original_name}</h3>
				<p className="mb-10">{truncate(movie?.overview, 200)}</p>
				<button
					className="banner__button"
					onClick={(e) => {
						handleMovieClick(movie);
						e.stopPropagation();
					}}
				>
					<FontAwesomeIcon icon={faPlay} />
					Play Trailer
				</button>
				<Link to={`/movie/${movie.id}`} className="banner__button">
					<FontAwesomeIcon icon={faInfoCircle} />
					More info
				</Link>
				{/* {isMessage ? (
					<p className="error">Sorry no trailer found!</p>
				) : (
					<button
						className="banner__button"
						onClick={() => ShowTrailer()}
					>
						<FontAwesomeIcon icon={faPlay} />
						Play Trailer
					</button>
				)} */}
			</div>
		</div>
	);
}

export default Movie;
